// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2iK8v","overflowing":"ReadFullNote_overflowing__3OzM7"};